import { rgba } from "polished";
import { useTheme } from "@mui/material";
import styled from "styled-components";

export const StyledContainer = (props) => {
  const theme = useTheme();
  return <_StyledContainer $theme={theme} {...props} />;
};

const _StyledContainer = styled.div`
  padding: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: ${({ $theme }) => rgba($theme.palette.secondary.main, 0.2)};
  border-radius: 4px;
  height: 100%;
  width: 100%;
  transition: all 500ms ease-in-out;
  box-shadow: ${({ $theme }) => $theme.shadows[2]};
  &:hover {
    background-color: ${({ $theme }) => rgba($theme.palette.secondary.main, 0.05)};
    border-radius: 1px;
    border-color: ${({ $theme }) => rgba($theme.palette.secondary.main, 0.4)};
  }
`;
